<template>
  <div id="firmwareDownload">
    <div class="content">
      <div class="steps">
        <el-steps finish-status="success" direction="vertical" :active="current">
          <el-step :title="$t('开始更新')" :description="$t('提示内容23')"></el-step>
          <el-step :title="$t('下载固件')" :description="$t('提示内容24')"></el-step>
          <el-step :title="$t('完成更新')" :description="$t('提示内容25')"></el-step>
        </el-steps>
      </div>
      <div class="stepContent">
        <div class="stepBox" v-show="current===0">
          <el-button v-wave type="primary" @click="downloadMode">{{$t('开始更新')}}</el-button>
          <div class="Warn">
            <h4><span class="warnSpan"><i class="el-icon-info"></i></span><span>{{ $t('提示') }}</span></h4>
            <p style="line-height: 0.25rem;margin: 0.2rem 0">
              {{$t('提示内容26')}}
            </p>
            <p style="line-height: 0.25rem;margin: 0.2rem 0">
              {{$t('提示内容27')}}
            </p>
          </div>
        </div>
        <div class="stepBox" v-show="current===1">
          <div style="display: flex;align-items: baseline;">
            <p style="margin-right: 0.2rem">
              <el-select v-model="editionValue" :placeholder="$t('提示内容28')" @change="editionChange">
                <el-option
                  v-for="item in editionOptions"
                  :key="item.value"
                  :label="$t(item.label)"
                  :value="item.value">
                </el-option>
              </el-select>
            </p>
            <el-button v-wave type="primary" @click="downloadFile">{{$t('下载固件')}}</el-button>
            <div style="margin-left: 0.2rem">
              <p>{{ $t('固件版本') }}：
                <span class="warnSpan">{{file.fileName}}</span>
              </p>
            </div>
          </div>
          <div class="Warn">
            <h4><span class="warnSpan"><i class="el-icon-info"></i></span><span>{{ $t('提示') }}</span></h4>
            <p style="line-height: 0.25rem;margin: 0.2rem 0">
              {{$t('提示内容29')}}
            </p>
            <p style="line-height: 0.25rem;margin: 0.2rem 0">
              {{$t('提示内容30')}}
            </p>
          </div>
        </div>
        <div class="stepBox" v-show="current===2">
          <el-result icon="success" :title="$t('提示内容31')"></el-result>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '../store/eventBus'
import { fetchWithRetry } from '@/store/utils.js'
export default {
  name: "firmwareDownload",
  props: ['productId'],
  data() {
    return {
      current: 0,
      editionValue: '',
      editionOptions: [
        {
          label: '稳定版本',
          value: '0'
        },
        {
          label: '最新版本',
          value: '1'
        }
        // {
        //   label: '开发版本（dev2）',
        //   value: '2'
        // }
      ],
      files: [
        {
          fileName: '0.0.9.uf2',
          fileUrl: './firmware/zent75/master/0.0.9.uf2'
        },
        {
          fileName: '0.0.18.uf2',
          fileUrl: './firmware/zent75/master/0.0.18.uf2'
        }
      ],
      file: {},
      intervalId: null,
      timerId: null,
      timerId1: null
    }
  },
  watch: {
    'current': {
      deep: true,
      async handler(newValue) {
        if (this.intervalId) {
          clearInterval(this.intervalId);
        }
        if (this.timerId) {
          clearTimeout(this.timerId);
        }
        if (this.timerId1) {
          clearTimeout(this.timerId1);
        }
        if (newValue === 1) {
          this.timerId = setTimeout(() => {
            this.intervalId = setInterval(async () => {
              let devices = await navigator.hid.getDevices();
              // 筛选出特定的设备
              const specificDevices = devices.filter(device => {
                return (device.vendorId === 0x36B0 && device.productId === 13694);
              });
              if (specificDevices.length !== 0) {
                this.$notify({
                  title: this.$t('警告'),
                  message: this.$t('提示内容32'),
                  type: 'warning',
                  offset: 100
                });
                this.timerId1 = setTimeout(() => {
                  location.reload()
                },2000)
              }
            },3000)
          },1000)
        } else if (newValue === 2) {
          // 清除循环器
          if (this.intervalId) {
            clearInterval(this.intervalId);
          }
          if (this.timerId) {
            clearTimeout(this.timerId);
          }
          if (this.timerId1) {
            clearTimeout(this.timerId1);
          }
        }
      }
    }
  },
  mounted() {
    EventBus.$on('downloadModeResult',this.handleDownload)
  },
  methods: {
    editionChange() {
      if (this.editionValue === '0') {
        this.file = this.files[0]
      } else if (this.editionValue === '1') {
        this.file = this.files[1]
      }
    },
    handleDownload(val) {
      if (val) {
        this.current = 1
      }
    },
    downloadMode() {
      // if(this.productId === 13694) { // zent75
      //   this.$set(this, 'file', this.files[0])
      // }
      EventBus.$emit('downloadMode')
    },
    async downloadFile() {
      if (this.editionValue !== '') {
        if (!('showSaveFilePicker' in window)) {
          this.$notify.error({
            title: this.$t('错误'),
            message: this.$t('提示内容33'),
            offset: 100
          });
          return;
        }
        let responseResult = null
        await fetchWithRetry(this.file.fileUrl, { cache: 'no-store' }).then(data => {
          responseResult = data
        }).catch(error => {
          this.$notify.error({
            title: this.$t('错误'),
            message: this.$t('提示内容34'),
            offset: 100
          });
          throw error
        });

        // // Fetch the file from the server
        // let  response = null
        // await fetch(this.file.fileUrl,{ cache: 'no-store' }).then( responseResult => {
        //
        // })
        // if (!response.ok) {
        //   throw new Error('Network response was not ok');
        // }

        if (!responseResult) {
          return
        }
        const blob = await responseResult.blob();

        // Define the file options
        const options = {
          types: [{
            description: 'UF2 File',
            accept: {
              'application/octet-stream': ['.uf2']
            }
          }]
        };

        // Show the save file picker
        const handle = await window.showSaveFilePicker({
          suggestedName: this.file.fileName,
          types: options.types
        });

        const writableStream = await handle.createWritable();
        await writableStream.write(blob);
        // await writableStream.close();

        setTimeout(async () => {
          let devices = []
          // 获取所有已授权的 HID 设备
          devices = await navigator.hid.getDevices();
          // 筛选出特定的设备
          const specificDevices = devices.filter(device => {
            return (device.vendorId === 0x36B0 && device.productId === 13694);
          });

          if (specificDevices.length === 0) {
            this.$notify.error({
              title: this.$t('错误'),
              message: this.$t('提示内容35'),
              offset: 100
            });
          } else {
            if (this.intervalId) {
              clearInterval(this.intervalId);
            }
            if (this.timerId) {
              clearTimeout(this.timerId);
            }
            if (this.timerId1) {
              clearTimeout(this.timerId1);
            }
            this.$notify({
              title: this.$t('成功'),
              message: this.$t('提示内容36'),
              type: 'success',
              offset: 100
            })
            EventBus.$emit('getIsReload',true)
            this.current = 2
            setTimeout(() => {
              location.reload()
            },1000)
          }
        },3000)
      } else {
        this.$notify.info({
          title: '提示',
          message: '请先选择你需要更新的固件版本',
          offset: 100
        })
      }
    }
  },
  beforeDestroy() {
    // 清除循环器
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    if (this.timerId) {
      clearTimeout(this.timerId);
    }
    if (this.timerId1) {
      clearTimeout(this.timerId1);
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../style/handle.scss';
#firmwareDownload {
  width: 100%;
  height: 8rem;
  border-radius: 0.1rem;
  box-sizing: border-box;
  padding: 0.2rem;
  box-shadow: 0.01rem 0.01rem 0.05rem rgba(0, 0, 0, 0.3);
  text-align: left;
  @include background_color('bg_color');
  .steps {
    margin-right: 0.4rem;
    /deep/.el-steps {
      .el-step__head {
        width: 0.24rem;
        .el-step__line {
          width: 0.02rem;
          left: 0.11rem;
        }
        .el-step__icon {
          width: 0.24rem;
          height: 0.24rem;
          font-size: 0.14rem;
        }
        .el-step__icon.is-text {
          border-width: 0.02rem;
        }
      }
      .el-step__main {
        padding-left: 0.1rem;
        .el-step__title {
          line-height: 0.24rem;
          margin-bottom: 0.08rem;
          font-size: 0.16rem;
          padding-bottom: 0.08rem;
        }
        .el-step__description {
          margin-top: -0.05rem;
          font-size: 0.12rem;
          line-height: 0.2rem;
        }
      }
    }
  }
  .content {
    display: flex;
    .stepContent {
      width: 8rem;
      .warnSpan {
        display: inline-block;
        color: #ff8000;
        font-weight: 700;
        i {
          font-size: 0.2rem;
          font-weight: 700 !important;
        }
      }
      .stepBox {
        .buttons-p {
          width: 1.2rem;
          height: 0.5rem;
          padding: 0.1rem;
          border-radius: 0.25rem;
          box-shadow: 0.01rem 0.01rem 0.05rem rgba(0, 0, 0, 0.3);
          text-align: -webkit-center;
          margin-bottom: 0.3rem;
          margin-right: 0.3rem;
          @include background_color('btn-color-out');
          .el-button {
            width: 100%;
            height: 0.3rem;
            //border-radius: 0.2rem;
            line-height: 0.3rem;
            box-shadow: 0.01rem 0.01rem 0.05rem rgba(0, 0, 0, 0.3);
            margin: 0;
            //padding: 0;
            border: none;
            font-size: 0.14rem;
            padding: 0.12rem 0.2rem;
            border-radius: 0.04rem;
            @include font_color('btn_color');
            @include background_color('btn_bg_color');
            @include border_color('btn_border_color');
          }
          .el-button:hover {
            @include background_color('btn_bg_color_hover');
          }
        }
        .Warn {
          padding: 0.2rem;
          border-radius: 0.1rem;
          @include font_color('font_color');
        }
        /deep/.el-result {
          .el-result__icon svg {
            width: 1rem;
            height: 1rem;
          }
          .el-result__title {
            p {
              @include font_color('font_color')
            }
          }
        }
        /deep/ .el-select {
          width: 2.2rem;
        }
      }
    }
  }
}
</style>
